export default __webpack_public_path__ + "static/media/ico-deposit011.e05d1182.svg";